module.exports = __webpack_public_path__ + "img/do1ne.359dcbcc.png";